export default __webpack_public_path__ + "static/media/geetanjal-khanna-8CwoHpZe3qE-unsplash-1.a25b0214.jpg";